<template>
  <v-container class="pa-4 pa-sm-8" fluid>
    <v-layout>
      <v-flex xs12 sm8 md4 lg3>
        <h2 class="dark--text font-weight-bold">Contact Us</h2>
      </v-flex>
    </v-layout>
    <v-layout wrap class="mt-3 mt-sm-0 mb-2">
      <v-flex xs12 sm8 md4 lg3>
        <v-text-field solo dense name="input-7-4" label="Search" @keydown.enter="runSearch()" v-model="filter.searchKey"></v-text-field>
      </v-flex>
      <v-flex xs5 sm3 md2 class="ml-4 mx-sm-2">
        <v-menu v-model="menuFromDate" :close-on-content-click="false" max-width="290">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field :value="searchStartDateDate" label="From" solo class="ms-sm-1" append-icon="fa-calendar-alt dark--text" v-bind="attrs" v-on="on" dense></v-text-field>
          </template>
          <v-date-picker color="primary" v-model="appFromDate" @change="selectFromDate"></v-date-picker>
        </v-menu>
      </v-flex>

      <v-flex xs5 sm3 md2 class="ml-4 mx-sm-2">
        <v-layout>
          <v-menu v-model="menuToDate" :close-on-content-click="false" max-width="290">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field :value="searchEndDateDate" label="To Date" solo class="" append-icon="fa-calendar-alt dark--text" v-bind="attrs" v-on="on" @click:clear="appToDate = null" dense>
              </v-text-field>
            </template>
            <v-date-picker color="primary" v-model="appToDate" @change="selectToDate"></v-date-picker>
          </v-menu>
        </v-layout>
      </v-flex>

      <v-flex xs12 sm8 md4 lg3>
        <ExportContactUs class="mt-n3" :contactUsList="contactUsList" :headers="headers" />
      </v-flex>
    </v-layout>

    <v-data-table
      :mobile-breakpoint="0"
      :headers="headers"
      :items="contactUsList"
      class="elevation-1"
      :items-per-page="25"
      :options.sync="options"
      :loading="loading"
      :server-items-length="totalItems"
      :footer-props="{ 'items-per-page-options': [25, 50, 100, 500] }"
    >
      <template v-slot:item.firstName="{ item }"> {{ capitalizeFirstLetter(item.firstName) }} {{ capitalizeFirstLetter(item.lastName) }} </template>
      <template v-slot:item.phone="{ item }">
        {{ item.phone }}
      </template>
      <template v-slot:item.email="{ item }">
        {{ item.email }}
      </template>

      <template v-slot:item.message="{ item }">
        {{ capitalizeFirstLetter(item.message) }}
      </template>
      <template v-slot:item.createdAt="{ item }">
        {{ new Date(parseInt(item.createdAt)) | moment("MMM DD YYYY") }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import ExportContactUs from "../components/ExportContactUs.vue";
import moment from "moment";
import { format, parseISO } from "date-fns";
export default {
  components: { ExportContactUs },

  mounted() {
    this.$root.$on("getAllContactUs", () => {
      this.loading = true;
      this.getAllContactUs();
    });
  },

  data: () => ({
    loading: true,
    totalItems: 25,
    contactUsList: [],
    appFromDate: format(
      parseISO(
        moment()
          .subtract(7, "days")
          .toDate()
          .toISOString()
      ),
      "yyyy-MM-dd"
    ),
    appToDate: format(
      parseISO(
        moment()
          .toDate()
          .toISOString()
      ),
      "yyyy-MM-dd"
    ),
    options: {
      itemsPerPage: 25,
      page: 1,
    },
    filter: {
      status: "ALL",
      searchKey: "",
    },

    menuFromDate: false,
    menuToDate: false,
    headers: [
      {
        text: "FirstName",
        value: "firstName",
        sortable: true,
        width: 150,
      },
      {
        text: "LastName",
        value: "lastName",
        sortable: true,
        width: 120,
      },

      {
        text: "Phone",
        value: "phone",
        sortable: false,
        width: 120,
      },

      {
        text: "Email",
        value: "email",
        sortable: false,
        width: 150,
      },
      {
        text: "Message",
        value: "message",
        sortable: false,
        width: 120,
      },
      {
        text: "Created Date",
        value: "createdAt",
        sortable: false,
        width: 120,
      },
    ],
  }),

  methods: {
    runSearch() {
      this.getAllContactUs();
    },
    getAllContactUs() {
      this.loading = true;
      this.$apollo
        .watchQuery({
          query: require("../api/getAllContactUs.graphql"),
          variables: {
            limit: 25,
            skip: 0,
            searchKey: this.filter.searchKey,
            startDate: this.appFromDate,
            endDate: this.appToDate,
          },
        })
        .refetch({
          limit: this.options.itemsPerPage !== -1 ? this.options.itemsPerPage : 200,
          skip: this.options.page * this.options.itemsPerPage - this.options.itemsPerPage,
          searchKey: this.filter.searchKey,
        })
        .then(data => {
          this.loading = false;
          if (data.data.getAllContactUs) {
            this.contactUsList = data.data.getAllContactUs.contactUs;
            this.totalItems = data.data.getAllContactUs.totalCount;
          }
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },
    selectToDate() {
      this.menuToDate = false;
      this.getAllContactUs();
    },
    selectFromDate() {
      this.menuFromDate = false;
      this.getAllContactUs();
    },
  },
  watch: {
    options: {
      handler() {
        this.getAllContactUs();
      },
      deep: true,
    },
  },
  created() {
    this.getAllContactUs();
    if (!this.hasRole(this.AdminUserPermissions.PLAN_TRANSFER_LIST)) {
      this.$router.push({
        name: "Error404",
      });
    }
  },
  computed: {
    searchStartDateDate() {
      return this.appFromDate ? moment(this.appFromDate).format("DD-MM-YYYY") : "";
    },
    searchEndDateDate() {
      return this.appToDate ? moment(this.appToDate).format("DD-MM-YYYY") : "";
    },
  },
};
</script>
